import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  QUALITY_TEXT,
  formatServerClock,
  hourQuality,
  serverClock,
} from '@/lib/serverTime';

/**
 * Compact live ST clock. Colours the time by the same "good / edge /
 * night" rules used on the World Clock page.
 */
export default function ServerClockChip() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const quality = hourQuality(serverClock(now).h);

  return (
    <Link
      to="/world-clock"
      title="Open World Clock"
      className="flex items-center gap-2 rounded-lg border border-slate-800 bg-slate-900 px-3 py-1.5 text-sm hover:bg-slate-800"
    >
      <span
        className={`font-mono tabular-nums ${QUALITY_TEXT[quality]}`}
      >
        {formatServerClock(now)}
      </span>
      <span className="text-xs text-slate-500">ST</span>
    </Link>
  );
}
